import { schema } from 'normalizr'

const companySchema = new schema.Entity('companies', {}, { idAttribute: 'companyId' })
const reservationSchema = new schema.Entity('reservations', {}, { idAttribute: 'reservationId' })

export const companiesSchema = new schema.Array(companySchema)
export const reservationsSchema = new schema.Array(reservationSchema)
